// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wRF2AlNQKi5XFEV6Jsyy{min-height:0}.WSBfS9mN_4NZwvhCfGjY{max-width:750px}`, "",{"version":3,"sources":["webpack://./src/components/settings/views/shared-settings/report-customization-form/report-customization-form.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CAGJ,sBACI,eAAA","sourcesContent":[".subPageLayout {\n    min-height: 0;\n}\n\n.formContent {\n    max-width: 750px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subPageLayout": `wRF2AlNQKi5XFEV6Jsyy`,
	"formContent": `WSBfS9mN_4NZwvhCfGjY`
};
export default ___CSS_LOADER_EXPORT___;
